import { render } from "./Error.vue?vue&type=template&id=800602d4"
import script from "./Error.vue?vue&type=script&setup=true&lang=js"
export * from "./Error.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/error/Error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "800602d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('800602d4', __exports__)) {
    console.log('reload')
    api.reload('800602d4', __exports__)
  }
  
  module.hot.accept("./Error.vue?vue&type=template&id=800602d4", () => {
    console.log('re-render')
    api.rerender('800602d4', render)
  })

}


export default __exports__